import styled, { css } from 'styled-components';
import { themeGet, color } from '@magalu/stereo-ui-styles';
import { slideFromTop, slideFromBottom, fadeIn } from '../../utils';
import Box from '../Box';
import Flex from '../Flex';
import Text from '../Text';
const paperPositions = {
  top: css`
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    animation: ${slideFromTop} 0.3s ease-in-out;
  `,
  center: css`
    margin: 15px;
    animation: ${fadeIn} 0.3s ease-in;
  `,
  bottom: css`
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    animation: ${slideFromBottom} 0.3s ease-in-out;
  `
};

const paperTypes = ({
  type,
  fullScreen
}) => {
  if (fullScreen) return css`
      width: 100%;
      border-radius: ${themeGet('radii.default')};
    `;
  if (type === 'alert') return css`
      width: 300px;
      border-radius: ${themeGet('radii.medium')};
    `;
  if (type === 'responsive') return css`
      padding: ${themeGet('space.4')}px;
      border-radius: ${themeGet('radii.default')};
      overflow-x: hidden;
    `;
  if (type === 'full') return css`
      max-width: 1366px;
      width: 100%;
    `;
  return css`
    width: 85%;
    max-width: 1366px;
    border-radius: ${themeGet('radii.default')};
  `;
};

const alignContentBy = {
  top: css`
    justify-content: flex-start;
  `,
  center: css`
    justify-content: center;
  `,
  bottom: css`
    justify-content: flex-end;
  `
};
export const Overlay = styled(Box).attrs(() => ({
  bg: 'background.overlay'
}))`
  animation: ${fadeIn} 0.3s linear;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  cursor: pointer;
`;
export const Container = styled(Flex).attrs(props => ({
  zIndex: 4,
  padding: props.fullScreen ? 4 : undefined
}))`
  flex-direction: column;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  ${props => alignContentBy[props.position]}
  visibility: ${({
  visible
}) => visible ? 'visible' : 'hidden'};
`;
export const Title = styled(Text).attrs(props => Object.assign({
  color: 'text.dark',
  fontSize: 3,
  p: 2
}, props.titleStyle))`
  margin: 6px 0;
  width: 100%;
`;
export const ContentHeader = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
export const HorizontalRule = styled.hr`
  height: ${({
  size
}) => `${size}px`};
  width: 100vh;
  border: none;
  ${color}
`;
export const Paper = styled(Box).attrs(props => Object.assign({
  p: 3,
  bg: 'background.base',
  zIndex: 1
}, props))`
  overflow-x: auto;
  ${props => paperPositions[props.position]}
  ${props => paperTypes(props)}
`;
export const Header = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
`;
export const CloseComponent = styled.div`
  padding-right: 8px;
  margin-left: auto;
  cursor: pointer;
`;